import * as Utils from '@ext/index';


export class Plataformas
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Plataformas
    {

        if ( id === this.Decidir.Id )
            return this.Decidir;
        else if ( id === this.MercadoPago.Id )
            return this.MercadoPago;
        else if ( id === this.Contado.Id )
            return this.Contado;
        else if ( id === this.Transferencia.Id )
            return this.Transferencia;
        else if ( id === this.NoEspecificado.Id )
            return this.NoEspecificado;


        return new Plataformas( id, id );
    }

    public static readonly Decidir: Plataformas = new Plataformas( 'decidir', 'Decidir SPS' );
    public static readonly MercadoPago: Plataformas = new Plataformas( 'mercadopago', 'MercadoPago' );
    public static readonly Contado: Plataformas = new Plataformas( 'efectivo', 'Contado efectivo' );
    public static readonly Transferencia: Plataformas = new Plataformas( 'transferencia', 'Transferencia' );
    public static readonly Deposito: Plataformas = new Plataformas( 'deposito', 'Deposito' );
    public static readonly Cheque: Plataformas = new Plataformas( 'cheque', 'Cheque' );
    public static readonly NoEspecificado: Plataformas = new Plataformas( 'no-especificado', 'No especificada' );

    public static Bancarios: Array<Plataformas> = [
        Plataformas.Contado,
        Plataformas.Transferencia,
        Plataformas.Cheque,
        Plataformas.Deposito,
    ]

    public static Options: Array<Plataformas> = [
        Plataformas.Contado,
        Plataformas.Decidir,
        Plataformas.MercadoPago,
        Plataformas.Contado,
        Plataformas.Transferencia,
        Plataformas.Decidir,
        Plataformas.Cheque,
        Plataformas.Deposito,
        Plataformas.NoEspecificado,
    ];

    public get esBancario(): boolean { return this.esTransferencia || this.esCheque || this.esDeposito; }
    public get esContado(): boolean { return this.Id === Plataformas.Contado.Id; }
    public get esDecidir(): boolean { return this.Id === Plataformas.Decidir.Id; }
    public get esMercadoPago(): boolean { return this.Id === Plataformas.MercadoPago.Id; }
    public get esTransferencia(): boolean { return this.Id === Plataformas.Transferencia.Id; }
    public get esDeposito(): boolean { return this.Id === Plataformas.Deposito.Id; }
    public get esCheque(): boolean { return this.Id === Plataformas.Cheque.Id; }
    public get esNoEspecificado(): boolean { return this.Id === Plataformas.NoEspecificado.Id; }

    public static get Filter(): { Nombre: string; Id: string, Valor: Plataformas[]; }[]
    {
        let tt: { Nombre: string; Id: string, Valor: Plataformas[]; }[] = [];
        for ( let t of Plataformas.Options )
        {
            tt.push( { Nombre: t.Descripcion, Id: t.Id, Valor: [t] } );
        }
        return tt;
    }

    public get Imagen(): string
    {
        if ( this.esMercadoPago )
            return Utils.settings.URL.static + "mercadopago.png";
        else if ( this.esDecidir )
            return Utils.settings.URL.static + "decidir.png";
        else
            return '';
    }

}

export class Tipos
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos
    {

        if ( id === this.MercadoPagoEnCuenta.Id )
            return this.MercadoPagoEnCuenta;
        else if ( id === this.TicketOffline.Id )
            return this.TicketOffline;
        else if ( id === this.Transferencia.Id )
            return this.Transferencia;
        else if ( id === this.ATM.Id )
            return this.ATM;
        else if ( id === this.TarjetaCredito.Id )
            return this.TarjetaCredito;
        else if ( id === this.TarjetaDebito.Id )
            return this.TarjetaDebito;
        else if ( id === this.TarjetaPrepaga.Id )
            return this.TarjetaPrepaga;
        else if ( id === this.PlanAhora.Id )
            return this.PlanAhora;
        else if ( id === this.PagoFacil.Id )
            return this.PagoFacil;
        else if ( id === this.PagoMisCuentas.Id )
            return this.PagoMisCuentas;
        else if ( id === this.Rapipago.Id )
            return this.Rapipago;
        else if ( id === this.Efectivo.Id )
            return this.Efectivo;
        else if ( id === this.NoEspecificado.Id )
            return this.NoEspecificado;


        return new Tipos( id, id );
    }

    public static readonly MercadoPagoEnCuenta: Tipos = new Tipos( 'mercadopago-en-cuenta', 'Dinero en MP' );
    public static readonly TicketOffline: Tipos = new Tipos( 'ticket-offline', 'Ticket Offline' );
    public static readonly Transferencia: Tipos = new Tipos( 'transferencia', 'Transferencia' );
    public static readonly ATM: Tipos = new Tipos( 'pago-atm', 'Pago en Cajero' );
    public static readonly TarjetaCredito: Tipos = new Tipos( 'tarjeta-credito', 'Tarjeta Crédito' );
    public static readonly TarjetaDebito: Tipos = new Tipos( 'tarjeta-debito', 'Tarjeta Débito' );
    public static readonly TarjetaPrepaga: Tipos = new Tipos( 'tarjeta-prepaga', 'Tarjeta Prepaga' );
    public static readonly PlanAhora: Tipos = new Tipos( 'plan-ahora', 'PlanAhora' );
    public static readonly PagoFacil: Tipos = new Tipos( 'pago-facil', 'PagoFacil' );
    public static readonly PagoMisCuentas: Tipos = new Tipos( 'pago-mis-cuentas', 'PagoMisCuentas' );
    public static readonly Rapipago: Tipos = new Tipos( 'rapipago', 'Rapipago' );
    public static readonly Efectivo: Tipos = new Tipos( 'efectivo', 'Efectivo' );
    public static readonly NoEspecificado: Tipos = new Tipos( 'no-especificado', 'No Especificado' );


    public static Options: Array<Tipos> = [
        Tipos.ATM,
        Tipos.MercadoPagoEnCuenta,
        Tipos.TicketOffline,
        Tipos.Transferencia,
        Tipos.ATM,
        Tipos.TarjetaCredito,
        Tipos.TarjetaDebito,
        Tipos.TarjetaPrepaga,
        Tipos.PlanAhora,
        Tipos.PagoFacil,
        Tipos.PagoMisCuentas,
        Tipos.Rapipago,
        Tipos.Efectivo,
        Tipos.NoEspecificado,
    ];


    public static get Filter(): { Nombre: string; Id: string, Valor: Tipos[]; }[]
    {
        let tt: { Nombre: string; Id: string, Valor: Tipos[]; }[] = [];
        tt.push( { Nombre: 'Todos', Id: 'todos', Valor: [] } );
        for ( let t of Tipos.Options )
        {
            tt.push( { Nombre: t.Descripcion, Id: t.Id, Valor: [t] } );
        }
        return tt;
    }

    public get esMercadoPagoEnCuenta(): boolean { return this.Id === Tipos.MercadoPagoEnCuenta.Id; }
    public get esTicketOffline(): boolean { return this.Id === Tipos.TicketOffline.Id; }
    public get esTransferencia(): boolean { return this.Id === Tipos.Transferencia.Id; }
    public get esATM(): boolean { return this.Id === Tipos.ATM.Id; }
    public get esTarjetaCredito(): boolean { return this.Id === Tipos.TarjetaCredito.Id; }
    public get esTarjetaDebito(): boolean { return this.Id === Tipos.TarjetaDebito.Id; }
    public get esTarjetaPrepaga(): boolean { return this.Id === Tipos.TarjetaPrepaga.Id; }
    public get esPlanAhora(): boolean { return this.Id === Tipos.PlanAhora.Id; }
    public get esPagoFacil(): boolean { return this.Id === Tipos.PagoFacil.Id; }
    public get esPagoMisCuentas(): boolean { return this.Id === Tipos.PagoMisCuentas.Id; }
    public get esRapipago(): boolean { return this.Id === Tipos.Rapipago.Id; }
    public get esEfectivo(): boolean { return this.Id === Tipos.Efectivo.Id; }
    public get esNoEspecificado(): boolean { return this.Id === Tipos.NoEspecificado.Id; }

}

export class Estados
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados
    {

        if ( id === this.Pendiente.Id )
            return this.Pendiente;
        else if ( id === this.Acreditado.Id )
            return this.Acreditado;
        else if ( id === this.Autorizado.Id )
            return this.Autorizado;
        else if ( id === this.EnProceso.Id )
            return this.EnProceso;
        else if ( id === this.EnDisputa.Id )
            return this.EnDisputa;
        else if ( id === this.Rechazado.Id )
            return this.Rechazado;
        else if ( id === this.Cancelado.Id )
            return this.Cancelado;
        else if ( id === this.Devuelto.Id )
            return this.Devuelto;
        else if ( id === this.Contracargo.Id )
            return this.Contracargo;


        return new Estados( id, id );
    }

    public static readonly Pendiente: Estados = new Estados( 'pendiente', 'Pendiente' );
    public static readonly Acreditado: Estados = new Estados( 'acreditado', 'Acreditado' );
    public static readonly Autorizado: Estados = new Estados( 'autorizado', 'Autorizado' );
    public static readonly EnProceso: Estados = new Estados( 'en-proceso', 'En proceso' );
    public static readonly EnDisputa: Estados = new Estados( 'en-disputa', 'En disputa' );
    public static readonly Rechazado: Estados = new Estados( 'rechazado', 'Rechazado' );
    public static readonly Cancelado: Estados = new Estados( 'cancelado', 'Cancelado' );
    public static readonly Devuelto: Estados = new Estados( 'devuelto', 'Devuelto' );
    public static readonly Contracargo: Estados = new Estados( 'contracargo', 'Contracargo' );

    public static Options: Array<Estados> = [
        Estados.Pendiente,
        Estados.Acreditado,
        Estados.Autorizado,
        Estados.EnProceso,
        Estados.EnDisputa,
        Estados.Rechazado,
        Estados.Cancelado,
        Estados.Devuelto,
        Estados.Contracargo,
    ];


    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: 'Pendientes', Valor: [Estados.Pendiente, Estados.EnProceso] },
        { Id: 2, Nombre: 'Acreditados', Valor: [Estados.Acreditado, Estados.Autorizado] },
        { Id: 3, Nombre: 'Con problemas', Valor: [Estados.EnDisputa] },
        { Id: 4, Nombre: 'Rechazados', Valor: [Estados.Rechazado] },
        { Id: 5, Nombre: 'Cancelados', Valor: [Estados.Cancelado] },
        { Id: 6, Nombre: 'Contracargos', Valor: [Estados.Contracargo] },
    ];

    public get esValido(): boolean { return this.esAcreditado || this.esAutorizado; }
    public get esAcreditado(): boolean { return this.Id === Estados.Acreditado.Id; }
    public get esAutorizado(): boolean { return this.Id === Estados.Autorizado.Id; }

    public get esPendiente(): boolean { return this.Id === Estados.Pendiente.Id; }
    public get esEnProceso(): boolean { return this.Id === Estados.EnProceso.Id; }

    public get esDevuelto(): boolean { return this.Id === Estados.Devuelto.Id; }
    public get esContracargo(): boolean { return this.Id === Estados.Contracargo.Id; }

    public get esEnDisputa(): boolean { return this.Id === Estados.EnDisputa.Id; }
    public get esRechazado(): boolean { return this.Id === Estados.Rechazado.Id; }
    public get esCancelado(): boolean { return this.Id === Estados.Cancelado.Id; }

    public get Color(): string
    {
        if ( this.esAcreditado || this.esAutorizado ) { return 'success'; }
        else if ( this.esDevuelto || this.esEnDisputa || this.esRechazado || this.esCancelado ) { return 'error'; }
        else return '';
    }

}


export class Financiaciones
{

    constructor( id: number, tasa: number, descripcion: string )
    {
        this.Id = id;
        this.Tasa = tasa;
        this.Descripcion = descripcion;
    }

    public readonly Id: number;
    public readonly Tasa: number;
    public readonly Descripcion: string;

    public static toTipo( id: number ): Financiaciones
    {

        if ( id === this.Ahora3.Id ) return this.Ahora3;
        else if ( id === this.Ahora6.Id ) return this.Ahora6;
        else if ( id === this.Ahora12.Id ) return this.Ahora12;
        else if ( id === this.Ahora18.Id ) return this.Ahora18;
        return new Financiaciones( id, 0, id.toString() );
    }

    public static Ahora3: Financiaciones = new Financiaciones( 13, 0.0244, "AHORA3" );
    public static Ahora6: Financiaciones = new Financiaciones( 16, 0.0475, "AHORA6" );
    public static Ahora12: Financiaciones = new Financiaciones( 7, 0.0915, "AHORA12" );
    public static Ahora18: Financiaciones = new Financiaciones( 8, 0.1326, "AHORA18" );
}